// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFMA5WWHlpV7Z1eoq3cG514ykWYilzSQE",
  authDomain: "resale-web-acab3.firebaseapp.com",
  projectId: "resale-web-acab3",
  storageBucket: "resale-web-acab3.appspot.com",
  messagingSenderId: "799373043151",
  appId: "1:799373043151:web:4b22278c490bd1f68adeba"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default  app